import {
	HAS_STRIPE_ACCOUNT,
	HAS_DETAILS_SUBMITTED,
	SET_FILTERED_INVOICES,
	SET_ALL_INVOICES,
	SET_TOTAL_INVOICES,
	HAS_MORE_INVOICES,
	SET_INVOICES_NEXT_CURSOR,
	SET_CUSTOMER_INVOICES,
	APPEND_INVOICES,
	APPEND_CUSTOMER_INVOICES,
	SET_ALL_CUSTOMER_INVOICES,
} from '../actions/types';

const INITIAL_STATE = {
	filteredInvoices: [],
	allInvoices: [],
	customerInvoices: [],
	allCustomerInvoices: [],
	totalCount: 0,
	totalCustomerCount: 0,
	hasMore: true,
	invoicesNextCursor: null,
	hasStripeAccount: false,
	hasDetailsSubmitted: false,
};

function paymentsReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case HAS_STRIPE_ACCOUNT:
			return { ...state, hasStripeAccount: action.payload };
		case HAS_DETAILS_SUBMITTED:
			return { ...state, hasDetailsSubmitted: action.payload };
		// set invoices will replace existing invoices with the new invoices supplied by action.payload
		case SET_FILTERED_INVOICES:
			return { ...state, filteredInvoices: action.payload };
		// set the invoices when we have all of them
		case SET_ALL_INVOICES:
			return { ...state, allInvoices: action.payload };
		// set the total count of invoices
		case SET_TOTAL_INVOICES:
			return { ...state, totalCount: action.payload };
		// set the customer Invoices
		case SET_CUSTOMER_INVOICES:
			return { ...state, customerInvoices: action.payload };
		// return the boolean that checks if there are more invoices to return
		case HAS_MORE_INVOICES:
			return { ...state, hasMore: action.payload };
		// opaque Stripe search page cursor for the status-filtered Pay path
		case SET_INVOICES_NEXT_CURSOR:
			return { ...state, invoicesNextCursor: action.payload };
		// append new invoices to the existing invoices
		case APPEND_INVOICES:
			return {
				...state,
				filteredInvoices: [
					...state.filteredInvoices,
					...action.payload,
				],
			};
		case APPEND_CUSTOMER_INVOICES:
			return {
				...state,
				customerInvoices: [
					...state.customerInvoices,
					...action.payload,
				],
			};
		case SET_ALL_CUSTOMER_INVOICES:
			return { ...state, allCustomerInvoices: action.payload };
		default:
			return state;
	}
}

export default paymentsReducer;
